import { useCallback } from 'react'
import { useSearchParams } from 'react-router'

type AppSearchParams = Partial<{
  nodeId: string | null
  query: string | null
  pipelineId: string | null
  datatype: string | null
  groupBy: string | null
}>

export function useAppSearchParams() {
  const [searchParams, setSearchParams] = useSearchParams()

  const updateSearchParams = useCallback(
    (updates: AppSearchParams) => {
      const newParams = new URLSearchParams(searchParams)

      Object.entries(updates).forEach(([key, value]) => {
        if (value === null || value === undefined || value === '') {
          newParams.delete(key) // Remove invalid or empty values
        } else if (value !== searchParams.get(key)) {
          newParams.set(key, value) // Update only if different
        }
      })

      try {
        setSearchParams(newParams)
      } catch (error) {
        console.warn('Failed to update search params:', error)
      }
    },
    [searchParams, setSearchParams]
  )

  return {
    searchParams,
    updateSearchParams,
  }
}
